import { createAsyncAction } from "../actionCreators";
import { API } from "@thenounproject/lingo-core";

type Args = {
  spaceId: number;
};

const [useCancelSubscription, cancelSubscription] = createAsyncAction(
  "billing/cancelSubscription",
  async ({ spaceId }: Args) => {
    const res = await API.call<{ space: string }>({
      endpoint: `spaces/${spaceId}/plan/`,
      method: "DELETE",
      data: {
        space_id: spaceId,
      },
    });
    return { ...res, result: res.result.space };
  }
);

export default useCancelSubscription;
export { cancelSubscription };
